export default __webpack_public_path__ + "static/7-e16c3af708738a6be3455a71efbf6d17.webp";